import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Icon } from '../icon'
import background from '../../assets/name_background.png'
import mask from '../../assets/avatar_mask.png'

export type BusinessCardStyle = 'default'
export interface BusinessCardProps {
  style?: BusinessCardStyle
  name: string
  title: string
  phone?: string
  email?: string
  address?: string
  avatar: string
  company?: {
    name: string
    logo: string
  }
}

const Container = styled.div`
  height: 13.75rem;
  width: 23.375rem;
  border-radius: 0.5rem;
  margin: 0 auto;
  background-color: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.outline};
  
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: stretch;
  
  overflow: hidden;
`
const Info =styled.div`
  flex: auto;
  padding: 0.75rem 0 0.75rem 1.25rem;
`
const Company = styled.div`
  height: 1.25rem;
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  img {
    height: 1.25rem;
    width: 1.25rem;
    border-radius: 0.25rem;
    margin-right: 0.25rem;
  }
  span {
    font-size: 0.75rem;
    font-weight: bold;
  }
`
const NameAndTitle = styled.div`
  position: relative;
  padding: 0.5rem 1.25rem;
  margin: 0 -0.5rem 0.75rem -1.25rem;
  background-image: url('${background}');
  background-size: cover;
  background-position: center;
  z-index: 3;
`
const Name = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
`
const Title = styled.div`
  font-size: 0.75rem;
`
const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  & > * + * {
    margin-top: 0.5rem;
  }
`
const Contact = styled.div`
  width: 10.5rem;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: baseline;
  & > * + * {
    margin-left: 0.5rem;
  }
  & > *:first-child {
    flex: none;
  }
  div {
    color: ${props => props.theme.colors.textLight};
    font-size: 0.75rem;
  }
`
const AvatarContainer = styled.div`
  position: relative;
  flex: none;
  height: 100%;
  width: 10.5rem;
  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 50px;
    background: url('${mask}') no-repeat left;
    background-size: contain;
    z-index: 2;
  }
`
const Avatar = styled.img`
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  //clip-path: path("M 30,0 C 0,50 0,170 20,220 H 168 V 0 H 30");
`
export const BusinessCard: React.VFC<BusinessCardProps> = ({
  style = 'default',
  name,
  title,
  phone,
  email,
  address,
  avatar,
  company
}) => {
  const { colors } = useTheme()
  return (
    <Container>
      <Info>
        <Company>
          {company && (
            <>
              <img src={company.logo} alt="company logo"/>
              <span>{company.name}</span>
            </>
          )}
        </Company>
        <NameAndTitle>
          <Name>{name}</Name>
          <Title>{title}</Title>
        </NameAndTitle>
        <Contacts>
          {phone && (
            <Contact>
              <Icon code="24gf-phoneBubble" size={12} color={colors.grayDark} />
              <div>{phone}</div>
            </Contact>
          )}
          {email && (
            <Contact>
              <Icon code="youjian" size={12} color={colors.grayDark} />
              <div>{email}</div>
            </Contact>
          )}
          {address && (
            <Contact>
              <Icon code="didian2" size={12} color={colors.grayDark} />
              <div>{address}</div>
            </Contact>
          )}
        </Contacts>
      </Info>
      <AvatarContainer>
        <Avatar src={avatar} />
      </AvatarContainer>
    </Container>
  )
}

